import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import authentication from "@irati/auth"
import Form from "@irati/ui/src/Form"
import {H3} from "@irati/ui/src/Typography/Heading"
import {Hr} from "@irati/ui/src/Layout"
import tracking from "@irati-tracking/recognition/recognition"
import CreateRecognitionMutation from "@irati/recognition/apollo/mutation/Recognition/Create"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import {CompanyValuesSelect} from "@irati-web/fields/companyValues"
import OccasionsSelect from "@irati-web/fields/occasions/OccasionsSelect"
import {Share} from "@irati-web/fields/poll"
import getSharingOptions from "@irati/recognition/constants/share"
import isShareableWithTeams from "@irati/recognition/utils/isShareableWithTeams"
import {Message} from "@irati-web/fields/recognition"
import UserSearch from "@irati/ui/src/UserSearch"
import getId from "@irati/utils/id"

import {SUCCESS} from "."

import CTA from "../shared/CTA"

const StyledForm = styled(Form)`
  textarea {
    resize: vertical;
    min-height: 40px;
  }

  .Select-control > *:last-child {
    padding-right: 10px;
  }
`

class CreateRecognition extends Component {
  static propTypes = {
    recognition: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    selectScreen: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired
  }

  static defaultProps = {
    id: "createRecognition"
  }

  handleCancel = () => {
    const {selectScreen} = this.props

    tracking.cancelRecognition()
    selectScreen(null)
  }

  handleRecognitionCreationComplete = () => {
    const {recognition, selectScreen} = this.props

    tracking.launchRecognition(recognition)
    selectScreen(SUCCESS)
  }

  handleOccasionsChange = (value) => {
    const {onChange, recognition} = this.props
    onChange(recognition, "occasionId", value)
  }

  handleRecognitionError = (response) => {
    tracking.errorsRecognition(response)
  }

  handleUserChange = (_, users) => {
    const {onChange, recognition} = this.props
    // this is stupid, userIds is an array of users, obviously.
    onChange(recognition, "userIds", users || [])
  }

  render() {
    const {onChange, recognition, formatMessage} = this.props
    const canShareWithEveryone = authentication.apps("recognition.recognition.everyone")
    const user = authentication.user()
    const canBeSharedWithTeams = isShareableWithTeams(user, recognition)
    const sharingOptions = getSharingOptions(formatMessage, canShareWithEveryone, canBeSharedWithTeams)

    return (
      <div>
        <H3>
          <FormattedMessage id="recognition.popup.createRecognition.create.header" />
        </H3>
        <Hr />
        <StyledForm>
          <UserSearch
            hideLabel
            onChange={this.handleUserChange}
            removeSelf
            isMulti
            autoFocus
            label="recognition.fields.recognition.winners.label"
            placeholder="recognition.fields.recognition.winners.placeholder" />
          <Message
            hideLabel
            label={formatMessage({id: "recognition.popup.createRecognition.create.message.label"})}
            placeholder={formatMessage({id: "recognition.popup.createRecognition.create.message.placeholder"})}
            poll={recognition}
            onChange={onChange} />
          <OccasionsSelect selectedOption={recognition.occasionId} onChange={this.handleOccasionsChange} />
          <CompanyValuesSelect item={recognition} onChange={onChange} />
          <Share options={sharingOptions} poll={recognition} onChange={onChange} hasTeams={canBeSharedWithTeams} />
        </StyledForm>
        <CreateRecognitionMutation
          onCompleted={this.handleRecognitionCreationComplete}
          onError={this.handleRecognitionError}
          recognition={recognition}>
          {(onClick, apolloState) => (
            <CTA
              id={getId("submitButton", this.props)}
              onNext={onClick}
              onCancel={this.handleCancel}
              apolloState={apolloState}
              nextText={formatMessage({id: "recognition.popup.createRecognition.create.cta"})} />
          )}
        </CreateRecognitionMutation>
      </div>
    )
  }
}

export default injectIntl(CreateRecognition)
